import request from './request'

const schedulingService = {
    /**
     * 获取当前登录教师的个人课表
     */
    getMyTimetable: () => {
        return request.get('/academic/scheduling/timetable/my/')
    }
}

export default schedulingService
